var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "6 6 18 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.144 20h-1.208L15 16.336 14.073 20h-1.208l-1.53-5.336h1.274l.935 3.856 1.016-3.856h.889l1.008 3.856.927-3.856h1.28zM15 8c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .898-2 2-2m6.5 4h-3.054A3.96 3.96 0 0 0 19 10a4 4 0 0 0-8 0c0 .732.21 1.409.555 2H8.5L6 23h18z"
})));
export default SvgWeight;